import Api from '@api';

import clientCommon from './blocks/common'
import clientTag from './blocks/tag'

import { formConfig } from './config/formConfig'

export default {
  name: 'preAdviceLineDetail',
  components: {
    clientCommon,
    clientTag
  },
  data() {
    return {
      current:'',
      clientCommonData: {
        _current: ''
      },
    };
  },
  computed:{
    injectData(){
      return this.$route.query || { _current:'' }
    }
  },
  activated() {
    this.$nextTick(()=>{
      this.init();
    })
  },
  mounted() {
    this.$nextTick(()=>{
      this.init();
    })
  },
  methods: {
    async init(){
      this.getOrderLineData();
    },
    async getOrderLineData() {
      this.setCurrent('line')
      if(!this.injectData.LINE_ID) return ;
      let { status, data } = await Api.GetPreadviceLineInfo({CLIENT_ID: this.injectData.CLIENT_ID,PRE_ADVICE_ID: this.injectData.PRE_ADVICE_ID,LINE_ID: this.injectData.LINE_ID});
      if (Number(status) === 200) {

        let result = JSON.parse(JSON.stringify(data));
        this.$refs.clientCommon.$refs.clientCommon.formData = result;

        let QTY_DUE = result.QTY_DUE || 0
        let QTY_DUE_TOLERANCE = result.QTY_DUE_TOLERANCE || 0
        result.QTY_DUE_TOLERANCE$QTY_DUE = Number(QTY_DUE) * (1+ Number(QTY_DUE_TOLERANCE))

        formConfig(this).thead
          .filter(item => item !== "THead")
          .forEach(item => {
            this.$refs.clientTag.$refs[item][0].formData = result
          })
      }
    },
    getOrderHeaderData(){
      this.$router.push({
        path:'/preAdviceHeadDetail',
        query:{
          CLIENT_ID: this.injectData.CLIENT_ID,
          PRE_ADVICE_ID: this.injectData.PRE_ADVICE_ID
        }
      })
    },
    /*
    * 设置当前查询的是行还是列
    * */
    setCurrent(name){
      this.clientCommonData._current = name
      this.current = name
    },
    toGetLineList(){
      this.$store.commit('SET_CURRENT_HEADERS',{model:'preAdvice',header:[this.injectData.PRE_ADVICE_ID]})
      this.$store.commit('SET_CURRENT_TAB',{model:'preAdvice',currentTab:'lineCom'})
      this.$router.push('/preAdvice')
    },
    handleConfirm() {},
    handleClose() {
      this.$emit('close')
    }
  }
}